import { useApiPrivateFileRequest } from "../../../shared/hooks/useApiFile";
import {
  EventName,
  EventParameter,
  sendEvent,
} from "../../../shared/utils/UsageAnalytics";

export const useExportChat = () => {
  const { isLoading: isExporting, call } = useApiPrivateFileRequest();
  const exportChat = async (chatId: string) => {
    sendEvent(EventName.ExportChatSent, {
      [EventParameter.ChatId]: chatId,
    });
    await call(`/chats/${chatId}/pdf`, "GET");
  };

  return { isExporting, exportChat };
};
